import validations from 'common-validator-fif-payments';

import { getEnv } from '@config';
import { REGIONS } from '@constants/regions';
import { reverseFullAmount } from './utils';

const { country } = getEnv();

export const isName = (name, limit) => {
  const sanitized = cleanString(name || '').substring(0, 50);
  if (/^[A-Za-z0-9\s]+$/.test(sanitized)) {
    if (limit === true) return true;
    return sanitized.length > 0 && sanitized.length <= 21;
  }
  return false;
};

export const isBusinessName = (value) => isStringWithoutMoreOrLess(value);
export const selectNull = (id) => document.getElementById(id).value.length > 1;
export const isRequired = (value) => (value || '').length !== 0;
export const validAdress = (value) => (value || '').length >= 3;

export const isChileAdress = (value) => {
  const str = String(value || '');
  return str.indexOf('Chile') > -1;
};

export const hasMiniumLength = (value, size) => (value || '').length >= size;
export const hasMaximunLength = (value, size) => (value || '').length <= size;
export const hasChile = (value) => (value || '').toLowerCase().indexOf(' chile') !== -1;

export const isNumber = (number) => {
  const str = String(number || '').substring(0, 20);
  return /^[0-9]+$/.test(str);
};

export const isCurrencyNumber = (number) => {
  const { decimalCount } = REGIONS[country];
  const str = String(reverseFullAmount(number || '')).substring(0, 25);
  
  if (decimalCount === 2) {
    return /^\d+$|^\d+\.\d{2}$/.test(str);
  }
  if (decimalCount === 0) {
    return /^\d+$/.test(str);
  }
  return /^\d+(\.\d+)?$/.test(str);
};

export const isCellPhone = (cellNumber) => /^[0-9]{9}$/.test(String(cellNumber || '').substring(0, 10));

export const isTelephoneWithOutArea = (telNumber) => {
  const str = String(telNumber || '').substring(0, 10);
  return /^[0-9]{9}$/.test(str);
};

export const isBankAccount = (accountNumber) => {
  const str = String(accountNumber || '').substring(0, 25);
  const c = country.toLowerCase();
  const maps = { cl: /^[0-9]{1,20}$/, pe: /^[0-9]{10,18}$/, co: /^[0-9]{4,16}$/ };
  return maps[c] ? maps[c].test(str) : false;
};

export const isInterbankAccountCode = (cci) => /^[0-9]{20}$/.test(String(cci || '').substring(0, 22));

export const isAreaTelephone = (areaNumber) => /^[0-9]{2}$/.test(String(areaNumber || '').substring(0, 4));

export const cleanStringLetters = (string) => {
  if (string != null) {
    return string
      .replace(/[ÁÀÄÂÃ]/g, 'A')
      .replace(/[ÉÈËÊẼ]/g, 'E')
      .replace(/[ÍÌÏÎĨ]/g, 'I')
      .replace(/[ÓÒÖÔÕ]/g, 'O')
      .replace(/[ÚÙÜÛŨ]/g, 'U')
      .replace(/[áàäâã]/g, 'a')
      .replace(/[éèëêẽ]/g, 'e')
      .replace(/[íìïîĩ]/g, 'i')
      .replace(/[óòöôõ]/g, 'o')
      .replace(/[úùüûũ]/g, 'u')
      .replace(/[Ñ]/g, 'N')
      .replace(/ñ/g, 'n')
      .replace(/\./g, '')
      .trim()
      .split(/ +/)
      .join(' ');
  }
  return string;
};

export const cleanString = (string) => {
  if (string != null) {
    return cleanStringLetters(string)
      .replace(/,/g, '')
      .toUpperCase();
  }
  return string;
};

export const isIdentificationDocument = (identification, docType = '') => {
  if (!identification) return false;
  const input = String(identification);
  const safeId = input.substring(0, 12);
  const c = country.toLowerCase();

  if (c === 'cl') {
    if (!/^[0-9kK-]+$/.test(safeId)) return false;
    const regexRut = /^([0-9]{1,8})-?([0-9kK])$/;
    return regexRut.test(safeId) && validations.isIdForCountry(safeId, c);
  }
  
  if (c === 'co') {
    return validations.isIdForCountry(safeId, c, String(docType).toUpperCase());
  }
  return validations.isIdForCountry(safeId, c, String(docType).toLowerCase());
};

export const isEmptyString = (text) => !text || !text.trim().length;

export const isValidCountry = (countryId) => validations.isValidCountry(countryId);

export const isValidDocumentType = (countryId, documentTypeId) =>
  validations.isValidDocumentType(countryId, documentTypeId);

export const isValidId = (id, docType) => validations.isValidId(id, docType);

export const isPhoneChile = (numberPhone) => {
  if (!numberPhone) return false;
  let str = String(numberPhone);
  if (str.startsWith('+')) str = str.substring(1);
  const safePhone = str.substring(0, 15);
  
  return /^56(\s|-?)[1-9](\s|-?)[0-9]{8}$|^[1-9][0-9]{8}$/.test(safePhone);
};

export const isPhoneForCountry = (country, phone) => {
  if (country.toLowerCase() === 'cl') return isPhoneChile(phone);
  return false;
};

export const containsValue = (stringToCompare, originalString) => {
  return String(originalString).indexOf(stringToCompare) > -1;
};

export const equalStrictValue = (originalValue, newValue) => originalValue === newValue;

export const repeatValue = (value) => {
  const str = String(value || '').substring(0, 20);
  return /(.)\1{3}/.test(str);
};

export const isConsecutiveNumber = (value) => {
  if (value.length <= 2) return false;
  const pattern = '0123456789' + '876543210';
  return pattern.indexOf(value) !== -1;
};

export const isConsecutiveCharacter = (value) => {
  if (value.length <= 2) return false;
  const str = String(value).substring(0, 20);
  return /(.)\1\1\1/.test(str);
};

export const isCorrectLength = (value, sz = 6) => value.length === sz;

export const isValidNumericPassword = (pass, rut, phone = '') =>
  !containsValue(pass, rut) &&
  !isConsecutiveNumber(pass) &&
  !repeatValue(pass) &&
  !containsValue(pass, phone) &&
  isNumber(pass) &&
  isCorrectLength(pass);

export const docTypeByCountryToNumberMap = {
  CL: { RUT: '01' },
  PE: { DNI: '1', CE: '4' },
  CO: { CC: '1', CE: '3', PAS: '5' },
  AR: { LE: 'LE', DNI: 'DNI', CI: 'CI', LC: 'LC', TJP: 'TJP' },
};

export const getDocTypeNumberByCountry = (country, docType) =>
  docTypeByCountryToNumberMap[country.toUpperCase()][docType.toUpperCase()];

export const isStringWithoutMoreOrLess = (string) => !/[<>丰富]/.test(string || '');

export const isStringWithoutSpecialCharacters = (string) => /^[0-9a-zA-Z]+$/.test(string || '');
export const isStringWithSpacesWithoutSpecialCharacters = (string) =>
  /^[0-9a-zA-Z ]+$/.test(string || '');
export const isStringWithSpacesWithAccentsWithoutSpecialCharacters = (string) =>
  /^[0-9A-Za-zÀ-ÖØ-öø-ÿ ]+$/.test(string || '');
export const isStringWithoutSpecialCharactersAndNumbers = (string) =>
  /^[a-zA-Z ]+$/.test(string || '');
export const isStringWithSpacesWithoutSpecialCharactersAndNumbers = (string) =>
  /^[a-zA-Z\s]*$/.test(string || '');
export const isStringWithoutSpecialCharactersAndNumbersAndSpaces = (string) =>
  /^[a-zA-Z]+$/.test(string || '');
export const areTwoWords = (string) => {
  const str = cleanStringLetters(string || '').substring(0, 50);
  return /^([a-zA-Z]{1,}\s[a-zA-z]{1,})$/.test(str);
};
export const hasNameLength = (string) => validations.isName(string, 20, 2);

export const businessLength = (string) => string.length > 2 && string.length <= 100;
export const addressInfoLength = (string) => string.length <= 100;
export const qrNameLength = (value) => value.length <= 50;

export const isValidEmail = (email) => {
  const str = String(email || '').substring(0, 100);
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(str);
};

export const formFieldHaveValue = (value) => `${value || ''}`.length <= 1;

export const formFieldsHaveValue = (list) =>
  list.reduce((prev, value) => prev || formFieldHaveValue(value), false);